/* VIBVSTUDIO — theme scripts */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var parser = new DOMParser();
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function parseHTML(html) {
    return parser.parseFromString(html, 'text/html');
  }

  function define(name, ctor) {
    if (!customElements.get(name)) customElements.define(name, ctor);
  }

  /* ---------- Toast ---------- */

  var toastTimer;
  function toast(message) {
    var el = qs('[data-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.hidden = true;
    }, 3200);
  }

  /* ---------- Scroll lock (menu + cart drawer) ---------- */

  var scrollLocks = {};
  function lockScroll(key, on) {
    var root = document.documentElement;
    var wasLocked = Object.keys(scrollLocks).length > 0;
    if (on) scrollLocks[key] = true;
    else delete scrollLocks[key];
    var locked = Object.keys(scrollLocks).length > 0;
    // keep the classic desktop scrollbar's space so the page does not jump sideways
    if (locked && !wasLocked) root.classList.toggle('has-scrollbar', window.innerWidth > root.clientWidth);
    root.classList.toggle('scroll-locked', locked);
  }

  function focusQuietly(el) {
    if (!el || !el.focus) return;
    try {
      el.focus({ preventScroll: true });
    } catch (error) {
      el.focus();
    }
  }

  /* ---------- Cart API ---------- */

  var Cart = {
    sections: function () {
      var ids = ['cart-icon-bubble'];
      if (qs('cart-drawer')) ids.push('cart-drawer');
      var main = qs('[data-main-cart]');
      if (main && main.dataset.sectionId) ids.push(main.dataset.sectionId);
      return ids;
    },

    render: function (sections) {
      if (!sections) return;

      var bubbleHTML = sections['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubbleHTML && bubble) {
        var bubbleDoc = parseHTML(bubbleHTML);
        var bubbleSource = bubbleDoc.querySelector('.shopify-section') || bubbleDoc.body;
        bubble.innerHTML = bubbleSource.innerHTML;
      }

      var drawerHTML = sections['cart-drawer'];
      var current = document.getElementById('CartDrawer-Inner');
      if (drawerHTML && current) {
        var fresh = parseHTML(drawerHTML).getElementById('CartDrawer-Inner');
        if (fresh) current.replaceWith(fresh);
      }

      var main = qs('[data-main-cart]');
      if (main && sections[main.dataset.sectionId]) {
        var freshMain = parseHTML(sections[main.dataset.sectionId]).querySelector('[data-main-cart]');
        if (freshMain) main.replaceWith(freshMain);
      }
    },

    add: function (formData) {
      formData.append('sections', Cart.sections().join(','));
      formData.append('sections_url', window.location.pathname);
      return fetch(theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message || theme.strings.error);
          Cart.render(data.sections);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          return data;
        });
    },

    change: function (line, quantity) {
      return fetch(theme.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: Cart.sections(),
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message || theme.strings.error);
          Cart.render(data.sections);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          return data;
        });
    },

    usesDrawer: function () {
      return theme.cartType === 'drawer' && !!qs('cart-drawer');
    },

    afterAdd: function () {
      var drawer = qs('cart-drawer');
      if (Cart.usesDrawer()) {
        drawer.open();
      } else {
        window.location.href = theme.routes.cart_url;
      }
    }
  };

  window.VibvCart = Cart;

  /* ---------- Cart drawer ---------- */

  define(
    'cart-drawer',
    class CartDrawer extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        var drawer = this;

        this.addEventListener('click', function (event) {
          if (event.target.closest('[data-drawer-close]')) drawer.close();
        });

        this.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') drawer.close();
          if (event.key === 'Tab') drawer.trapFocus(event);
        });

        document.addEventListener('click', function (event) {
          var toggle = event.target.closest('[data-cart-toggle]');
          if (!toggle || theme.cartType !== 'drawer') return;
          event.preventDefault();
          drawer.open(toggle);
        });
      }

      open(opener) {
        this.opener = opener || document.activeElement;
        this.classList.add('is-open');
        document.body.classList.add('drawer-open');
        lockScroll('cart', true);
        var panel = this.querySelector('.drawer__panel');
        window.setTimeout(function () {
          focusQuietly(panel);
        }, 60);
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        document.body.classList.remove('drawer-open');
        lockScroll('cart', false);
        focusQuietly(this.opener);
      }

      trapFocus(event) {
        var focusable = qsa('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', this.querySelector('.drawer__panel'));
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  );

  /* ---------- Cart lines (drawer + cart page) ---------- */

  var lineTimer;

  function setCartLoading(on) {
    qsa('[data-cart-items]').forEach(function (el) {
      el.classList.toggle('is-loading', on);
    });
  }

  function changeLine(line, quantity) {
    setCartLoading(true);
    return Cart.change(line, quantity)
      .catch(function (error) {
        toast(error.message);
      })
      .finally(function () {
        setCartLoading(false);
      });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-line-qty]');
    if (!input) return;
    clearTimeout(lineTimer);
    lineTimer = setTimeout(function () {
      changeLine(Number(input.dataset.line), Math.max(0, parseInt(input.value, 10) || 0));
    }, 300);
  });

  document.addEventListener('keydown', function (event) {
    var input = event.target.closest('[data-line-qty]');
    if (!input || event.key !== 'Enter') return;
    event.preventDefault();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-line-remove]');
    if (!remove) return;
    event.preventDefault();
    changeLine(Number(remove.dataset.lineRemove), 0);
  });

  /* ---------- Quantity input ---------- */

  define(
    'quantity-input',
    class QuantityInput extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        var self = this;
        this.addEventListener('click', function (event) {
          var button = event.target.closest('button[name="plus"], button[name="minus"]');
          var input = self.querySelector('input');
          if (!button || !input) return;
          event.preventDefault();
          var step = button.name === 'plus' ? 1 : -1;
          var min = input.min !== '' ? parseInt(input.min, 10) : 0;
          var max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
          var value = parseInt(input.value, 10) || 0;
          var next = Math.min(max, Math.max(min, value + step));
          if (next !== value) {
            input.value = next;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    }
  );

  /* ---------- Product form ---------- */

  define(
    'product-form',
    class ProductForm extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.form = this.querySelector('form');
        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        if (!Cart.usesDrawer()) return;
        event.preventDefault();
        var button = this.form.querySelector('[type="submit"]');
        var error = this.querySelector('[data-form-error]');
        if (!button || button.disabled) return;

        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }

        Cart.add(new FormData(this.form))
          .then(function () {
            Cart.afterAdd();
          })
          .catch(function (err) {
            if (error) {
              error.textContent = err.message;
              error.hidden = false;
            } else {
              toast(err.message);
            }
          })
          .finally(function () {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
          });
      }
    }
  );

  /* ---------- Quick add (product cards) ---------- */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-add-variant]');
    if (!button) return;
    event.preventDefault();

    var formData = new FormData();
    formData.append('id', button.dataset.addVariant);
    formData.append('quantity', '1');

    button.setAttribute('aria-busy', 'true');

    if (!Cart.usesDrawer()) {
      fetch(theme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      }).then(function () {
        window.location.href = theme.routes.cart_url;
      });
      return;
    }

    Cart.add(formData)
      .then(function () {
        Cart.afterAdd();
      })
      .catch(function (err) {
        toast(err.message);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  });

  /* ---------- Variant picker ---------- */

  define(
    'variant-picker',
    class VariantPicker extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        var data = this.querySelector('script[type="application/json"]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        this.addEventListener('change', this.onChange.bind(this));
      }

      selected() {
        return qsa('fieldset', this).map(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      onChange() {
        var options = this.selected();
        var section = this.closest('[data-product-section]') || document;

        qsa('fieldset', this).forEach(function (fieldset, index) {
          var label = fieldset.querySelector('[data-selected-value]');
          if (label && options[index]) label.textContent = options[index];
        });

        var variant = this.variants.find(function (candidate) {
          return candidate.options.every(function (value, index) {
            return value === options[index];
          });
        });

        var idInput = qs('form[data-type="add-to-cart-form"] [name="id"]', section);
        var button = qs('[data-add-button]', section);
        var label = qs('[data-add-label]', section);

        if (!variant) {
          if (button) button.disabled = true;
          if (label) label.textContent = theme.strings.unavailable;
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (button) button.disabled = !variant.available;
        if (label) label.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        this.updateMedia(section, variant);
        this.updatePrice(section, variant);
      }

      updateMedia(section, variant) {
        if (!variant.featured_media) return;
        var gallery = qs('[data-gallery]', section);
        if (!gallery) return;
        var item = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (item && gallery.firstElementChild !== item) gallery.prepend(item);
        if (gallery.scrollTo) gallery.scrollTo({ left: 0, behavior: 'smooth' });
      }

      updatePrice(section, variant) {
        var target = qs('[data-price]', section);
        if (!target || !this.dataset.url || !this.dataset.sectionId) return;
        var joiner = this.dataset.url.indexOf('?') > -1 ? '&' : '?';
        fetch(this.dataset.url + joiner + 'variant=' + variant.id + '&section_id=' + this.dataset.sectionId)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var fresh = parseHTML(html).querySelector('[data-price]');
            if (fresh) target.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      }
    }
  );

  /* ---------- Video intro ---------- */

  define(
    'video-hero',
    class VideoHero extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        var self = this;
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-video-toggle]');
        if (!this.video) return;

        this.video.muted = true;
        this.video.loop = true;
        this.video.setAttribute('playsinline', '');

        this.still = document.body.classList.contains('motion-off') || reduceMotion.matches;

        if (this.still) {
          this.video.removeAttribute('autoplay');
          this.pause();
        } else {
          this.play();
        }

        if (this.toggle) {
          this.toggle.addEventListener('click', function () {
            if (self.video.paused) {
              self.userPaused = false;
              self.play();
            } else {
              self.userPaused = true;
              self.pause();
            }
          });
        }

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (self.userPaused || self.still) return;
                if (entry.isIntersecting) self.play();
                else self.video.pause();
              });
            },
            { threshold: 0.1 }
          ).observe(this);
        }
      }

      play() {
        var self = this;
        var attempt = this.video.play();
        if (attempt && attempt.catch) {
          attempt.catch(function () {
            self.setState(true);
          });
        }
        this.setState(false);
      }

      pause() {
        this.video.pause();
        this.setState(true);
      }

      setState(paused) {
        this.classList.toggle('is-paused', paused);
        if (this.toggle) {
          this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
        }
      }
    }
  );

  /* ---------- Record player ----------
     The button on the record plays the official Spotify or SoundCloud player shown in the section,
     or an MP3 the shop owns. The official players are loaded only when the section comes near the screen. */

  var loaders = {};
  function loadScript(key, src, ready) {
    if (loaders[key]) return loaders[key];
    loaders[key] = new Promise(function (resolve, reject) {
      ready(resolve);
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onerror = function () {
        delete loaders[key];
        reject(new Error('load'));
      };
      document.head.appendChild(script);
    });
    return loaders[key];
  }

  function loadSpotify() {
    return loadScript('spotify', 'https://open.spotify.com/embed/iframe-api/v1', function (resolve) {
      var previous = window.onSpotifyIframeApiReady;
      window.onSpotifyIframeApiReady = function (api) {
        if (typeof previous === 'function') previous(api);
        resolve(api);
      };
    });
  }

  function loadSoundCloud() {
    return loadScript('soundcloud', 'https://w.soundcloud.com/player/api.js', function (resolve) {
      var timer = window.setInterval(function () {
        if (window.SC && window.SC.Widget) {
          window.clearInterval(timer);
          resolve(window.SC);
        }
      }, 50);
    });
  }

  define(
    'record-player',
    class RecordPlayer extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        var self = this;
        this.kind = this.dataset.player;
        this.button = this.querySelector('[data-player-toggle]');
        this.playing = false;
        if (!this.kind || !this.button) return;

        this.button.addEventListener('click', function () {
          self.toggle();
        });

        if (this.kind === 'mp3') {
          this.audio = this.querySelector('[data-player-audio]');
          if (!this.audio) return;
          this.audio.addEventListener('playing', function () {
            self.render(true);
          });
          this.audio.addEventListener('pause', function () {
            self.render(false);
          });
          this.audio.addEventListener('ended', function () {
            self.render(false);
          });
          this.audio.addEventListener('error', function () {
            self.render(false);
            toast(theme.strings.error);
          });
          return;
        }

        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
              observer.disconnect();
              self.prepare();
            },
            { rootMargin: '600px 0px' }
          );
          observer.observe(this);
        } else {
          this.prepare();
        }
      }

      prepare() {
        if (this._ready) return this._ready;
        var self = this;
        if (this.kind === 'spotify') {
          var host = this.querySelector('[data-player-embed]');
          this._ready = loadSpotify().then(function (api) {
            return new Promise(function (resolve) {
              api.createController(host, { uri: self.dataset.uri, width: '100%', height: 80 }, function (controller) {
                self.controller = controller;
                controller.addListener('playback_update', function (event) {
                  if (event && event.data) self.render(!event.data.isPaused);
                });
                controller.addListener('ready', function () {
                  resolve(controller);
                });
                window.setTimeout(function () {
                  resolve(controller);
                }, 3000);
              });
            });
          });
        } else if (this.kind === 'soundcloud') {
          var frame = this.querySelector('iframe[data-player-embed]');
          this._ready = loadSoundCloud().then(function (SC) {
            return new Promise(function (resolve) {
              var widget = SC.Widget(frame);
              self.widget = widget;
              widget.bind(SC.Widget.Events.READY, function () {
                resolve(widget);
              });
              widget.bind(SC.Widget.Events.PLAY, function () {
                self.render(true);
              });
              widget.bind(SC.Widget.Events.PAUSE, function () {
                self.render(false);
              });
              widget.bind(SC.Widget.Events.FINISH, function () {
                self.render(false);
              });
              window.setTimeout(function () {
                resolve(widget);
              }, 4000);
            });
          });
        } else {
          this._ready = Promise.reject(new Error('none'));
        }
        this._ready.catch(function () {
          self._ready = null;
        });
        return this._ready;
      }

      toggle() {
        var self = this;
        if (this.kind === 'mp3') {
          if (!this.audio) return;
          if (this.audio.paused) {
            var attempt = this.audio.play();
            if (attempt && attempt.catch) {
              attempt.catch(function () {
                self.render(false);
              });
            }
          } else {
            this.audio.pause();
          }
          return;
        }

        var start = !this.playing;
        this.render(start);
        this.prepare()
          .then(function (player) {
            if (self.kind === 'spotify') {
              if (!start) player.pause();
              else if (self._started) player.resume();
              else player.play();
            } else if (start) {
              player.play();
            } else {
              player.pause();
            }
            if (start) self._started = true;
          })
          .catch(function () {
            self.render(false);
            toast(theme.strings.error);
          });
      }

      render(on) {
        this.playing = on;
        this.classList.toggle('is-playing', on);
        this.button.setAttribute('aria-pressed', on ? 'true' : 'false');
        this.button.setAttribute('aria-label', on ? this.button.dataset.labelPause : this.button.dataset.labelPlay);
      }
    }
  );

  /* ---------- Photo strip ----------
     The photos drift sideways and loop without a seam: the row is repeated until it is wider than the screen,
     then followed by one copy of itself, and the track is moved by exactly one row before it starts again.
     Dragging moves it by hand and a flick carries on before it settles back into the drift.
     With reduced motion (or animations turned off in theme settings) it is a still row that scrolls sideways. */

  define(
    'photo-strip',
    class PhotoStrip extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this.viewport = this.querySelector('[data-strip-viewport]');
        this.track = this.querySelector('[data-strip-track]');
        this.group = this.querySelector('[data-strip-group]');
        this.toggleButton = this.querySelector('[data-strip-toggle]');
        if (!this.viewport || !this.track || !this.group || !this.group.children.length) return;
        this._bound = true;

        var self = this;
        this.speed = Math.max(0, parseFloat(this.dataset.speed) || 0);
        this.sign = this.dataset.direction === 'right' ? 1 : -1;
        this.hoverPause = this.dataset.hoverPause !== 'false';
        this.draggable = this.dataset.draggable !== 'false';
        this.originals = Array.prototype.slice.call(this.group.children);
        this.x = 0;
        this.v = 0;
        this.period = 0;
        this.pauses = {};
        this.visible = !('IntersectionObserver' in window);
        this.tick = this.tick.bind(this);

        // pointer: drag and flick
        this.viewport.addEventListener('pointerdown', function (event) {
          self.onDown(event);
        });
        this.viewport.addEventListener('pointermove', function (event) {
          self.onMove(event);
        });
        this.viewport.addEventListener('pointerup', function (event) {
          self.onUp(event, false);
        });
        this.viewport.addEventListener('pointercancel', function (event) {
          self.onUp(event, true);
        });
        this.viewport.addEventListener('dragstart', function (event) {
          event.preventDefault();
        });
        // a drag must not also open the photo's link
        this.addEventListener(
          'click',
          function (event) {
            if (self.dragEndedAt && performance.now() - self.dragEndedAt < 400) {
              event.preventDefault();
              event.stopPropagation();
            }
          },
          true
        );

        // mouse over the strip: glide to a stop
        this.addEventListener('pointerenter', function (event) {
          if (event.pointerType === 'mouse' && self.hoverPause) self.setPause('hover', true);
        });
        this.addEventListener('pointerleave', function (event) {
          if (event.pointerType === 'mouse') self.setPause('hover', false);
        });

        // keyboard: hold still while a photo link has focus and keep it on screen
        this.addEventListener('focusin', function (event) {
          self.setPause('focus', true);
          self.reveal(event.target);
        });
        this.addEventListener('focusout', function (event) {
          if (!self.contains(event.relatedTarget)) self.setPause('focus', false);
        });
        this.viewport.addEventListener('scroll', function () {
          // focus can scroll the clipped row; the track position is ours to keep
          if (!self.still && self.viewport.scrollLeft) self.viewport.scrollLeft = 0;
        });

        if (this.toggleButton) {
          this.toggleButton.addEventListener('click', function () {
            self.setUserPaused(!self.pauses.user);
          });
        }

        // theme editor: hold still on the selected photo
        this.onBlockSelect = function (event) {
          if (!self.contains(event.target)) return;
          self.setPause('editor', true);
          self.reveal(event.target);
        };
        this.onBlockDeselect = function (event) {
          if (self.contains(event.target)) self.setPause('editor', false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.onMotionChange = function () {
          self.setup();
        };
        if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', this.onMotionChange);
        else if (reduceMotion.addListener) reduceMotion.addListener(this.onMotionChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            function (entries) {
              self.visible = entries[entries.length - 1].isIntersecting;
              if (self.visible) self.start();
              else self.stop();
            },
            { rootMargin: '120px 0px' }
          );
          this.observer.observe(this);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(function () {
            self.scheduleRefill();
          });
          this.resizeObserver.observe(this.viewport);
        }

        this.setup();
      }

      disconnectedCallback() {
        if (!this._bound) return;
        this._bound = false;
        this.stop();
        if (this.observer) this.observer.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        if (reduceMotion.removeEventListener) reduceMotion.removeEventListener('change', this.onMotionChange);
        else if (reduceMotion.removeListener) reduceMotion.removeListener(this.onMotionChange);
      }

      isStill() {
        return reduceMotion.matches || document.body.classList.contains('motion-off') || this.speed === 0;
      }

      setup() {
        var still = this.isStill();
        if (this._mode === (still ? 'still' : 'drift')) return;
        this._mode = still ? 'still' : 'drift';
        this.still = still;
        this.stop();
        this.clear();
        this.classList.toggle('is-still', still);
        this.classList.toggle('is-ready', !still);
        if (still) return;
        this.x = 0;
        this.v = 0;
        this.fill();
        this.render();
        if (this.visible) this.start();
      }

      // repeat the photos until the row covers the screen, then add one copy of the whole row
      fill() {
        var self = this;
        var unit = this.group.getBoundingClientRect().width;
        this._w = this.viewport.clientWidth;
        this._h = this.group.offsetHeight;
        if (!unit || !this._w) return;
        var guard = 0;
        while (this.group.getBoundingClientRect().width < this._w && guard < 40) {
          guard++;
          this.originals.forEach(function (node) {
            self.group.appendChild(self.quietCopy(node));
          });
        }
        var copy = this.quietCopy(this.group);
        copy.removeAttribute('data-strip-group');
        this.track.appendChild(copy);
        this.period = this.group.getBoundingClientRect().width;
      }

      // copies are for the eye only: hidden from screen readers, never focusable, unknown to the theme editor
      quietCopy(node) {
        var copy = node.cloneNode(true);
        copy.setAttribute('data-strip-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        if ('inert' in copy) copy.inert = true;
        copy.removeAttribute('data-shopify-editor-block');
        qsa('[data-shopify-editor-block]', copy).forEach(function (el) {
          el.removeAttribute('data-shopify-editor-block');
        });
        qsa('a[href], button, [tabindex]', copy).forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        return copy;
      }

      clear() {
        qsa('[data-strip-clone]', this.track).forEach(function (node) {
          if (node.parentNode) node.parentNode.removeChild(node);
        });
        this.track.style.transform = '';
        this.period = 0;
      }

      scheduleRefill() {
        var self = this;
        if (this._refill || this.still) return;
        this._refill = window.requestAnimationFrame(function () {
          self._refill = 0;
          if (self.still) return;
          if (self.viewport.clientWidth === self._w && self.group.offsetHeight === self._h && self.period) return;
          var progress = self.period ? self.x / self.period : 0;
          self.clear();
          self.fill();
          self.x = progress * self.period;
          self.render();
          self.wake();
        });
      }

      setPause(reason, on) {
        if (on) this.pauses[reason] = true;
        else delete this.pauses[reason];
        this.wake();
      }

      // the frame loop sleeps while the strip stands still or is off screen
      wake() {
        if (this.visible) this.start();
      }

      isPaused() {
        return Object.keys(this.pauses).length > 0;
      }

      setUserPaused(on) {
        this.setPause('user', on);
        this.classList.toggle('is-user-paused', on);
        if (this.toggleButton) {
          this.toggleButton.setAttribute('aria-label', on ? this.toggleButton.dataset.labelPlay : this.toggleButton.dataset.labelPause);
        }
      }

      start() {
        if (this.running || this.still || !this.period) return;
        this.running = true;
        this.last = 0;
        this.raf = window.requestAnimationFrame(this.tick);
      }

      stop() {
        this.running = false;
        if (this.raf) window.cancelAnimationFrame(this.raf);
        this.raf = 0;
      }

      tick(now) {
        this.raf = 0;
        if (!this.running) return;
        var dt = this.last ? Math.min(0.05, (now - this.last) / 1000) : 0;
        this.last = now;
        if (!this.dragging) {
          var paused = this.isPaused();
          var target = paused ? 0 : this.speed * this.sign;
          // ease toward the target speed: a soft stop under the mouse, a soft start, a flick that settles
          this.v += (target - this.v) * Math.min(1, dt * (paused ? 4 : 2.2));
          if (paused && Math.abs(this.v) < 0.5) this.v = 0;
          if (this.v) {
            this.x += this.v * dt;
            this.render();
          } else if (paused) {
            this.running = false;
            return;
          }
        }
        this.raf = window.requestAnimationFrame(this.tick);
      }

      render() {
        var p = this.period;
        if (p > 0) this.x = ((this.x % p) - p) % p;
        this.track.style.transform = 'translate3d(' + this.x.toFixed(2) + 'px, 0, 0)';
      }

      reveal(target) {
        var item = target && target.closest ? target.closest('.photo-strip__item') : null;
        if (!item || this.still) return;
        var box = this.viewport.getBoundingClientRect();
        var rect = item.getBoundingClientRect();
        if (rect.left >= box.left && rect.right <= box.right) return;
        this.x += box.left + 16 - rect.left;
        this.v = 0;
        this.render();
      }

      onDown(event) {
        if (!this.draggable || this.pressed) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        // a still row scrolls natively on touch; only the mouse needs help there
        if (this.still && event.pointerType !== 'mouse') return;
        if (event.target.closest('[data-strip-toggle]')) return;
        // keeps Chrome from treating the press as the start of a native drag, which would cancel the pointer
        if (event.pointerType === 'mouse') event.preventDefault();
        this.pressed = true;
        this.moved = false;
        this.pointerId = event.pointerId;
        this.startX = event.clientX;
        this.startOffset = this.still ? this.viewport.scrollLeft : this.x;
        this.samples = [[event.timeStamp, event.clientX]];
      }

      onMove(event) {
        if (!this.pressed || event.pointerId !== this.pointerId) return;
        var dx = event.clientX - this.startX;
        if (!this.moved) {
          if (Math.abs(dx) < 6) return;
          this.moved = true;
          this.dragging = true;
          this.classList.add('is-dragging');
          try {
            this.viewport.setPointerCapture(event.pointerId);
          } catch (error) {}
        }
        if (this.still) {
          this.viewport.scrollLeft = this.startOffset - dx;
        } else {
          this.x = this.startOffset + dx;
          this.render();
        }
        this.samples.push([event.timeStamp, event.clientX]);
        if (this.samples.length > 8) this.samples.shift();
      }

      onUp(event, cancelled) {
        if (!this.pressed || event.pointerId !== this.pointerId) return;
        this.pressed = false;
        if (!this.moved) return;
        this.moved = false;
        this.dragging = false;
        this.classList.remove('is-dragging');
        this.dragEndedAt = performance.now();
        if (this.still || cancelled) return;
        // carry the release speed; tick() lets it settle back into the drift
        var last = this.samples[this.samples.length - 1];
        var recent = this.samples.filter(function (sample) {
          return last[0] - sample[0] <= 100;
        });
        var first = recent[0];
        var seconds = (last[0] - first[0]) / 1000;
        var velocity = seconds > 0.004 ? (last[1] - first[1]) / seconds : 0;
        this.v = Math.max(-2400, Math.min(2400, velocity));
        this.wake();
      }
    }
  );

  /* ---------- Mobile menu ---------- */

  var MENU_CLOSE_FALLBACK = 600;

  define(
    'menu-drawer',
    class MenuDrawer extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        var self = this;
        this.details = this.querySelector('details');
        if (!this.details) return;
        this.summary = this.details.querySelector('summary');
        this.panel = this.querySelector('.menu-drawer__panel');
        if (!this.summary || !this.panel) return;

        // the summary no longer toggles <details> by itself: opening and closing are animated
        this.summary.addEventListener('click', function (event) {
          event.preventDefault();
          if (self.isOpen()) self.close(true);
          else self.open();
        });

        this.addEventListener('click', function (event) {
          if (event.target.closest('[data-menu-close]')) {
            self.close(true);
            return;
          }
          // an in-page link (#section) should not leave the sheet on top
          var link = event.target.closest('.menu-drawer__panel a[href]');
          if (link && link.hash && link.pathname === window.location.pathname) self.close(false, true);
        });

        this.addEventListener('keydown', function (event) {
          if (!self.isOpen()) return;
          if (event.key === 'Escape') {
            event.stopPropagation();
            self.close(true);
          } else if (event.key === 'Tab') {
            self.trapFocus(event);
          }
        });

        // the sheet only exists below 990px; rotating a tablet past that closes it
        var wide = window.matchMedia('(min-width: 990px)');
        var onWide = function () {
          if (wide.matches) self.close(false, true);
        };
        if (wide.addEventListener) wide.addEventListener('change', onWide);
        else if (wide.addListener) wide.addListener(onWide);

        // coming back with the browser's back button must not restore an open, locked sheet
        window.addEventListener('pageshow', function (event) {
          if (event.persisted) self.close(false, true);
        });

        if (this.details.open) this.open();
      }

      isOpen() {
        return this.details.open && !this.classList.contains('is-closing');
      }

      open() {
        var self = this;
        this.stopClosing();
        this.details.open = true;
        document.body.classList.add('menu-open');
        lockScroll('menu', true);
        // commit the off-screen position first so the slide always runs
        this.panel.getBoundingClientRect();
        window.requestAnimationFrame(function () {
          if (self.details.open && !self.classList.contains('is-closing')) self.classList.add('is-open');
        });
        focusQuietly(this.panel.querySelector('[data-menu-close]') || this.panel);
      }

      close(returnFocus, instant) {
        if (!this.details || !this.details.open) return;
        var self = this;
        this.classList.remove('is-open');
        if (returnFocus) focusQuietly(this.summary);
        if (instant || reduceMotion.matches) {
          this.finishClosing();
          return;
        }
        if (this.classList.contains('is-closing')) return;
        this.classList.add('is-closing');
        this._onEnd = function (event) {
          if (event.target === self.panel && event.propertyName === 'transform') self.finishClosing();
        };
        this.panel.addEventListener('transitionend', this._onEnd);
        this._timer = window.setTimeout(function () {
          self.finishClosing();
        }, MENU_CLOSE_FALLBACK);
      }

      stopClosing() {
        window.clearTimeout(this._timer);
        if (this._onEnd) this.panel.removeEventListener('transitionend', this._onEnd);
        this._onEnd = null;
        this.classList.remove('is-closing');
      }

      finishClosing() {
        this.stopClosing();
        this.classList.remove('is-open');
        this.details.open = false;
        document.body.classList.remove('menu-open');
        lockScroll('menu', false);
      }

      trapFocus(event) {
        var focusable = qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', this.panel);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        var active = document.activeElement;
        if (event.shiftKey && (active === first || !this.panel.contains(active))) {
          event.preventDefault();
          focusQuietly(last);
        } else if (!event.shiftKey && (active === last || !this.panel.contains(active))) {
          event.preventDefault();
          focusQuietly(first);
        }
      }
    }
  );

  /* ---------- Header dropdowns: close on outside click ---------- */

  document.addEventListener('click', function (event) {
    qsa('.header__dropdown[open]').forEach(function (dropdown) {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
    });
  });

  /* ---------- Product recommendations ---------- */

  define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this._loaded || !this.dataset.url) return;
        this._loaded = true;
        var self = this;
        fetch(this.dataset.url)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var fresh = parseHTML(html).querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim().length) self.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      }
    }
  );

  /* ---------- Collection sort ---------- */

  define(
    'collection-sort',
    class CollectionSort extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        var select = this.querySelector('select');
        if (!select) return;
        select.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', select.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      }
    }
  );

  /* ---------- Localization selects ---------- */

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-localization-select]');
    if (!select || !select.form) return;
    if (select.name === 'language_code') {
      try {
        localStorage.setItem('vibv:language', select.value);
      } catch (error) {}
    }
    select.form.submit();
  });
})();
